let context = {};
let directDebitDataConfirmed = false;

const init = (ctx) => {
  context = ctx;
};

const createIframes = () => context.createIframes();
const setDirectDebitDataConfirmed = (value) => { directDebitDataConfirmed = value; };
const directDebitDataNotConfirmed = () => !directDebitDataConfirmed;

export default {
  init,
  createIframes,
  setDirectDebitDataConfirmed,
  directDebitDataNotConfirmed
};
